import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const MEMBER_CARD_API_URL = `${API_HOST}/api/memberCard`;
const MEMBER_CARD_TRANSACTION_RECORD_API_URL = `${MEMBER_CARD_API_URL}/record/transaction`;
const ISSUED_MEMBER_CARD_API_URL = `${API_HOST}/api/memberCard/issuedMemberCard`;
const ISSUED_MEMBER_CARD_BATCH_API_URL = `${ISSUED_MEMBER_CARD_API_URL}/batch`;
const ISSUED_MEMBER_CARD_BATCH_ROW_API_URL = `${ISSUED_MEMBER_CARD_BATCH_API_URL}/row`;

function* createMemberCard() {
  yield takeEvery(actions.CREATE_MEMBER_CARD, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], MEMBER_CARD_API_URL, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_MEMBER_CARD_ENDED });
    }
  });
}

function* createIssuedMemberCards() {
  yield takeEvery(actions.CREATE_ISSUED_MEMBER_CARD, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], ISSUED_MEMBER_CARD_API_URL, formData, {
        timeout: 300000, // 30 seconds
      });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_ISSUED_MEMBER_CARD_ENDED });
    }
  });
}

function* searchMemberCards() {
  yield takeEvery(actions.SEARCH_MEMBER_CARDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${MEMBER_CARD_API_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MEMBER_CARDS_ENDED });
    }
  });
}

function* searchIssuedMemberCardBatches() {
  yield takeEvery(actions.SEARCH_ISSUED_MEMBER_CARD_BATCHES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${ISSUED_MEMBER_CARD_BATCH_API_URL}?${parameters.toString()}`,
        { timeout: 300000 }, // 5 minute
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_ISSUED_MEMBER_CARD_BATCHES_ENDED });
    }
  });
}

function* searchIssuedMemberCardBatchRows() {
  yield takeEvery(actions.SEARCH_ISSUED_MEMBER_CARD_BATCH_ROWS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${ISSUED_MEMBER_CARD_BATCH_ROW_API_URL}?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_ISSUED_MEMBER_CARD_BATCH_ROWS_ENDED });
    }
  });
}

function* searchMemberCardTransactionRecords() {
  yield takeEvery(actions.SEARCH_MEMBER_CARD_TRANSACTION_RECORDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${MEMBER_CARD_TRANSACTION_RECORD_API_URL}?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MEMBER_CARD_TRANSACTION_RECORDS_ENDED });
    }
  });
}

function* findMemberCard() {
  yield takeEvery(actions.FIND_MEMBER_CARD, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${MEMBER_CARD_API_URL}/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.FIND_MEMBER_CARD_ENDED });
    }
  });
}

function* updateMemberCard() {
  yield takeEvery(actions.UPDATE_MEMBER_CARD, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], MEMBER_CARD_API_URL, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_MEMBER_CARD_ENDED });
    }
  });
}

function* updateIssuedMemberCardBatch() {
  yield takeEvery(actions.UPDATE_ISSUED_MEMBER_CARD_BATCH, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], ISSUED_MEMBER_CARD_BATCH_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_ISSUED_MEMBER_CARD_BATCH_ENDED });
    }
  });
}

function* updateIssuedMemberCards() {
  yield takeEvery(actions.UPDATE_ISSUED_MEMBER_CARDS, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], ISSUED_MEMBER_CARD_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_ISSUED_MEMBER_CARDS_ENDED });
    }
  });
}

function* deleteMemberCards() {
  yield takeEvery(actions.DELETE_MEMBER_CARDS, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], MEMBER_CARD_API_URL, { data });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_MEMBER_CARDS_ENDED });
    }
  });
}

function* getMemberCardsStatistics() {
  yield takeEvery(actions.GET_MEMBER_CARDS_STATISTICS, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${MEMBER_CARD_API_URL}/${id}/statistics`,
        { timeout: 300000 }, // 5 minute
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_MEMBER_CARDS_STATISTICS_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createMemberCard),
    fork(createIssuedMemberCards),
    fork(searchMemberCards),
    fork(searchIssuedMemberCardBatches),
    fork(searchIssuedMemberCardBatchRows),
    fork(searchMemberCardTransactionRecords),
    fork(findMemberCard),
    fork(updateMemberCard),
    fork(updateIssuedMemberCardBatch),
    fork(updateIssuedMemberCards),
    fork(deleteMemberCards),
    fork(getMemberCardsStatistics),
  ]);
}
